<template>
    <path d="M 12,2 C 6.48,2 2,6.48 2,12 2,17.52 6.48,22 12,22 17.52,22 22,17.52 22,12 22,6.48 17.52,2 12,2 Z M 10,17 6,13 7.41,11.59 10,14.17 16.59,7.58 18,9 Z"/>
</template>

<script>
    export default {
        name: 'done-full',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/DoneFull.vue